let isDev = false;
// let isDev = true;


class ConnUrls {
    static ApiUrl = isDev ? 'http://localhost:8000/api/' : 'https://caprise-ashdod-c54009a9f10f.herokuapp.com/api/';
    static mediasUrl = isDev ? 'http://localhost:3000' : 'https://caprise-ashdod-c54009a9f10f.herokuapp.com';
    static mediasLocalUrl = isDev ? 'http://localhost:4001' : 'https://caprise-admin.netlify.app/';
    // static servMediasUrl = !isDev ? 'http://localhost:8000/images/' : 'https://lolaimgs.s3.eu-central-1.amazonaws.com/images/';
    static servMediasUrl = 'https://caprisimgs.s3.eu-central-1.amazonaws.com/images';
    static socketClient = isDev ? 'http://localhost:9000/' : 'https://socket.caprise-ashdod-c54009a9f10f.herokuapp.com/';
}
export default ConnUrls;